import { useMemo } from 'react'
import { queryStringToObject } from '@ucheba/utils/helpers/router'
import dayjs from '@ucheba/utils/helpers/date/dayjs'

export const useEmbedVideoUrl = (url: string | null | undefined): string | null => {
  const nameYoutube = {
    long: 'youtube',
    short: 'youtu.be',
  }

  const isYoutube = useMemo(
    () => url?.includes(nameYoutube.long) || url?.includes(nameYoutube.short),
    [url, nameYoutube]
  )

  const idUrl = useMemo(() => {
    if (!isYoutube || !url) return null

    if (url?.includes(nameYoutube.long)) {
      return queryStringToObject(url).v
    }
    const urlArray = url.split('/')

    return urlArray[urlArray.length - 1]
  }, [nameYoutube.long, url, isYoutube])

  return useMemo(() => {
    if (!url || !isYoutube || !idUrl) {
      return null
    }

    return `https://www.youtube.com/embed/${idUrl}`
  }, [url, isYoutube, idUrl])
}

export const useFinishedEvent = (
  startAt: string | null | undefined,
  endAt: string | null | undefined
): boolean => {
  return useMemo(() => {
    const nowDate = dayjs()

    if (!endAt) {
      if (nowDate.unix() > dayjs(startAt).unix()) {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        if (nowDate.format('DD.MM.YYYY') === dayjs(startAt).format('DD.MM.YYYY')) {
          return nowDate.hour() >= 21
        }
        return true
      }

      return false
    }

    return nowDate.unix() >= dayjs(endAt).unix()
  }, [startAt, endAt])
}

export const isFinishedEvent = (
  startAt: string | null | undefined,
  endAt: string | null | undefined
): boolean => {
  const nowDate = dayjs()

  if (!endAt) {
    if (nowDate.unix() > dayjs(startAt).unix()) {
      if (nowDate.format('DD.MM.YYYY') === dayjs(startAt).format('DD.MM.YYYY')) {
        return nowDate.hour() >= 21
      }
      return true
    }

    return false
  }

  return nowDate.unix() >= dayjs(endAt).unix()
}
